const dateFormatter = new Intl.DateTimeFormat(undefined, { dateStyle: 'full' })
const timeFormatter = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
})
const clockFormatter = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
})
const dateOnlyFormatter = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
})

export function formatDateForInput(date) {
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    return `${year}-${month}-${day}`
}

export function formatSelectedDateLabel(value) {
    if (!value) {
        return ''
    }
    const parsed = new Date(`${value}T00:00:00`)
    if (Number.isNaN(parsed.getTime())) {
        return ''
    }
    return dateFormatter.format(parsed)
}

export function formatTimeRange(start, end, selectedDate = null) {
    if (start == null) {
        return null
    }

    const startDate = new Date(Number(start))
    if (Number.isNaN(startDate.getTime())) {
        return null
    }

    if (end == null) {
        return timeFormatter.format(startDate)
    }

    const endDate = new Date(Number(end))
    if (Number.isNaN(endDate.getTime())) {
        return timeFormatter.format(startDate)
    }

    const sameDay = startDate.toDateString() === endDate.toDateString()

    // Check if start date matches the selected search date
    let matchesSelectedDate = false
    if (selectedDate) {
        const parsedSelectedDate = new Date(`${selectedDate}T00:00:00`)
        if (!Number.isNaN(parsedSelectedDate.getTime())) {
            matchesSelectedDate = startDate.toDateString() === parsedSelectedDate.toDateString()
        }
    }

    if (sameDay) {
        const startClock = clockFormatter.format(startDate)
        const endClock = clockFormatter.format(endDate)

        // If matches search date, only show times
        if (matchesSelectedDate) {
            return `${startClock} - ${endClock}`
        }

        // Otherwise show full date with times
        const dayLabel = dateFormatter.format(startDate)
        return `${dayLabel} · ${startClock} - ${endClock}`
    }

    // Multi-day event - add warning emoji
    const warningEmoji = '⚠️'
    if (matchesSelectedDate) {
        // Starts on search date but ends on another day
        const endDateLabel = dateOnlyFormatter.format(endDate)
        const startClock = clockFormatter.format(startDate)
        return `${warningEmoji} ${startClock} - ${endDateLabel}`
    }

    // Spans multiple days, neither matching search date
    return `${warningEmoji} ${timeFormatter.format(startDate)} - ${timeFormatter.format(endDate)}`
}

function decodeHtml(value) {
    if (typeof value !== 'string') {
        return ''
    }
    return value
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
}

export function readableDescription(value) {
    const decoded = decodeHtml(value)
    if (!decoded) {
        return ''
    }
    return decoded
        .replace(/<br\s*\/?\>/gi, '\n')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\\n/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

export function toMapLink(item) {
    const lat = Number(item?.lat_y)
    const lon = Number(item?.lon_x)
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return null
    }

    const placeName = typeof item?.place_name === 'string' ? item.place_name.trim() : ''
    const address = typeof item?.address === 'string' ? item.address.trim() : ''

    const encodeForMaps = value => encodeURIComponent(value.replace(/\s+/g, '+'))

    if (placeName) {
        const encoded = encodeForMaps(placeName)
        return `https://maps.google.com/?q=${encoded}&near=@${lat},${lon},17z`
    }

    if (address) {
        const encoded = encodeForMaps(address)
        return `https://www.google.com/maps/place/${encoded}/@${lat},${lon},17z`
    }

    return `https://maps.google.com/?q=${lat},${lon}`
}
